export default __webpack_public_path__ + "static/media/head-right.34fbc345.png";